import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getImageRequests,
  updateImageRequest as apiUpdateImageRequest,
  deleteImageRequest as apiDeleteImageRequest,
} from '../../lib/imageRequests';

export const fetchImageRequests = createAsyncThunk(
  'imageRequests/fetchImageRequests',
  async ({ pagination = {}, options = {} } = {}) => {
    const data = await getImageRequests(pagination, options);
    return data;
  }
);

export const updateImageRequest = createAsyncThunk(
  'imageRequests/updateImageRequest',
  async ({ id, body }) => {
    const data = await apiUpdateImageRequest(id, body);
    return data;
  }
);

export const removeImageRequest = createAsyncThunk(
  'imageRequests/removeImageRequest',
  async (id) => {
    await apiDeleteImageRequest(id);
    return id;
  }
);
